import Tokens from '../Tokens';

const name = 'star';

const contents = `
<circle fill="#FFF" cx="55" cy="17" r="16"/>
<circle fill="${Tokens.iconBadgeFillColor}" cx="55" cy="17" r="14"/>
<path fill="#FFF" d="M55 21.75l-5.584 2.936 1.066-6.218-4.517-4.404 6.243-.907L55 7.5l2.792 5.657 6.243.907-4.517 4.404 1.066 6.218z"/>
`;

/** @type {import ('../types').Badge } */
const icon = {
  name,
  contents,
};

export default icon;
